// Library Class
import { Component, OnInit, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
// Service Class
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { PrePayService } from './../../../../services/common/pre-pay.service';
// Class
import { MasterConstants } from '../../../../common/constants/master-constants';
import { PrepayContractValidation } from '../../../../models/PrepayContractValidation';
import { DashboardFilter } from '../../../../models/DashboardFilter';
import { Subscription } from 'rxjs';
import { CommonService } from '../../../../services/common/common.service';

@Component({
  selector: 'app-new-prepay-request',
  templateUrl: './new-prepay-request.component.html',
  styleUrls: ['./new-prepay-request.component.scss']
})
export class NewPrePayRequestComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();

  ddlAccounts: any;
  contractId: string;
  prePayRequestAccount: number;
  prePayAmount: number;
  cropProtectionPrePayAmount: number;
  contractTypeList: any = [];
  errorsList: Array<string> = [];
  error = false;
  dashboardFilter: DashboardFilter;
  headerYear: any;
  isTnSDownloaded: boolean;
  headerCompany = MasterConstants.US_COMPANYCODE;
  accountList: any;
  datemodel: NgbDateStruct;
  dateFilterPrePay: any;
  prePayDate: any;
  fromDateFilter: any;
  toDateFilter: any;
  prePayContractType: string;
  isAgree = false;
  accessTypeMode = false;
  contractTypeSelected = false;
  canEnableSubmit = true;
  enableSubmit = false;
  prepayContractValidation: PrepayContractValidation;
  selectedProgram: any;
  applyType = 'Y';// Default apply type type auto
  orderViewtoggle = false;
  activeCropYear: any;
  termsSelected = false;

  @ViewChild('seedPrePayTable', { read: MatSort }) seedPrePaySort: MatSort;
  @ViewChild('seedPrePayPaginator', { read: MatPaginator }) seedPrePayPaginator: MatPaginator;
  seedPrePayColumns: string[] = ['prePaySupplierId', 'supplierName', 'prepayDueDate', 'gossUpPercentageRate'];

  @ViewChild('cropProtectionPrePayTable', { read: MatSort }) cropProtectionPrePaySort: MatSort;
  @ViewChild('cropProtectionPrePayPaginator', { read: MatPaginator }) cropProtectionPrePayPaginator: MatPaginator;
  cropProtectionPrePayColumns: string[] = ['cropProtectionPrePaySupplierId', 'supplierName', 'gossUpPercentageRate', 'prepayDueDate'];

  public seedPrePayDataSource: MatTableDataSource<any>;
  public cropProtectionPrePayDataSource: MatTableDataSource<any>;
  seedPrePayList: any = [];
  cropProtectionPrePayList: any = [];

  constructor(private localStorageService: LocalStorageService,
    private router: Router,
    private loaderService: LoaderService,
    private prePayService: PrePayService,
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private datePipe: DatePipe,
    private commonService: CommonService) {
    this.dashboardFilter = new DashboardFilter();
    this.prepayContractValidation = new PrepayContractValidation();
  }

  ngOnInit() {
    // Set the default value
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.subscription.push(this.activatedRoute.params.subscribe(x => {
      if (x['contractId']) {
        this.contractId = x['contractId'];
      }
    }));

    // Get Active CropYear
    if (this.localStorageService.get(MasterConstants.ACTIVE_CROP_YEAR)) {
      this.activeCropYear = JSON.parse(this.localStorageService.get(MasterConstants.ACTIVE_CROP_YEAR));
    }

    this.prePayService.selectedAccount = this.prePayService.accountNo;

    this.loaderService.setLoaderStatus(true);
    this.prePayDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.validateDateFilter();
    this.getAccountData();
    this.getContractTypeData();

    this.accessTypeMode = false;
    setTimeout(x => {
      this.accessTypeMode = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.PREPAY);
    }, 500);
  }

  // Get account list
  getAccountData() {
    this.dashboardFilter.cropYear = this.headerYear;
    this.subscription.push(this.prePayService.getAccountList(this.dashboardFilter).subscribe(result => {
      this.accountList = result['accounts'];
      this.prePayRequestAccount = this.prePayService.accountNo;
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // account change
  accountChange($event) {
    this.isAgree = false;
    this.canEnableSubmit = true;
    this.selectedProgram = undefined;
    this.enableSubmit = false;
    this.termsSelected = false;
    this.prePayAmount = undefined;
    this.cropProtectionPrePayAmount = undefined;
    this.applyType = 'Y';
    this.prePayContractType = undefined;
    this.contractTypeSelected = false;
    this.validateInput(false);
  }
  // Event fired on clearing selected account from dropdown
  clearAccount() {
    this.prePayRequestAccount = undefined;
  }

  // contract type change
  contractTypeChange($event) {
   
    if (this.prePayRequestAccount == undefined) {
      this.toastrService.warning('Please select Account Number');
      this.validateInput(false);
    }
    else {
      this.isAgree = false;
      this.canEnableSubmit = true;
      this.selectedProgram = undefined;
      this.enableSubmit = false;
      this.termsSelected = false;
      if (this.prePayContractType === 'SEED') {
        // Set the default value from SEED Terms and submission (T&S)
        if (this.localStorageService.get(MasterConstants.SEED_TERMS_AND_CONDITION_DOWNLOADED)) {
          this.isTnSDownloaded = JSON.parse(this.localStorageService.get(MasterConstants.SEED_TERMS_AND_CONDITION_DOWNLOADED));
          this.canEnableSubmit = false;
          this.isAgree = this.isTnSDownloaded;
        }
        this.prePayAmount = undefined;
        this.getSeedPrePayData();
      } else {
        // Set the default value from CPP Terms and submission (T&S)
        if (this.localStorageService.get(MasterConstants.CPP_TERMS_AND_CONDITION_DOWNLOADED)) {
          this.isTnSDownloaded = JSON.parse(this.localStorageService.get(MasterConstants.CPP_TERMS_AND_CONDITION_DOWNLOADED));
          this.canEnableSubmit = false;
          this.isAgree = this.isTnSDownloaded;
        }
        this.applyType = 'Y';// resetting the apply type value to auto
        this.cropProtectionPrePayAmount = undefined;
        this.getCropProtectionPrePayData();
      }
      this.contractTypeSelected = true;
      this.validateInput(false);
    }
  }

  // Get Seed PrePay Data
  getSeedPrePayData() {
    const currentDate = new Date();
    this.loaderService.setLoaderStatus(true);
    const data = {
      requestdate: this.datePipe.transform(currentDate, 'yyyy-MM-dd'),
      businessline: '04',
      startingcropyear: this.headerYear - 2001,
      accountnumber: this.prePayRequestAccount
    };

    this.subscription.push(this.prePayService.getSeedPrePayContractData(data).subscribe((results: any) => {
      if (results) {
        this.seedPrePayList = results;
        this.seedPrePayDataSource = new MatTableDataSource(this.seedPrePayList);
        this.seedPrePayDataSource.sort = this.seedPrePaySort;
        this.seedPrePayDataSource.paginator = this.seedPrePayPaginator;
        this.loaderService.setLoaderStatus(false);
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Get CPP data
  getCropProtectionPrePayData() {
    this.loaderService.setLoaderStatus(true);
    const currentDate = new Date();
    const data = {
      requestdate: this.datePipe.transform(currentDate, 'yyyy-MM-dd'),
      businessline: '02'
    };
    this.subscription.push(this.prePayService.getSeedPrePayContractData(data).subscribe((results: any) => {
      if (results) {
        this.loaderService.setLoaderStatus(true);
        this.cropProtectionPrePayList = results;
        this.cropProtectionPrePayDataSource = new MatTableDataSource(this.cropProtectionPrePayList);
        this.cropProtectionPrePayDataSource.sort = this.cropProtectionPrePaySort;
        this.cropProtectionPrePayDataSource.paginator = this.cropProtectionPrePayPaginator;
        this.loaderService.setLoaderStatus(false);
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Get Contract Type Data
  getContractTypeData() {
    this.contractTypeList.push('SEED');
    this.contractTypeList.push('CPP');
  }

  validateDateFilter() {
    this.dateFilterPrePay = (d: Date): boolean => {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);

      const calendarDate = d;
      let maxDate = new Date();
      if (this.headerYear) {
        maxDate = this.activeCropYear.endDate;
      }
      return calendarDate >= currentDate && calendarDate <= maxDate;
    };
  }

  // Validate date
  validatePrePayDate($event) {
    const currentDate = new Date();
    if ($event.value < currentDate) {
      this.prePayDate = new Date();
    }
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setNewPrePayPageHgt();
  }

  // set account table height
  setNewPrePayPageHgt() {
    const tableHeight = window.innerHeight - 150;
    $('.newPrePayOuter').css('max-height', tableHeight + 'px');
  }

  // get selected program on change event
  rateProgramChange(obj: any) {
    this.selectedProgram = obj;
    if (this.prePayContractType === 'SEED') {
      this.applyType = obj.automaticManualPrepay;
    }
    this.termsConditionsClicked($('#cbIsAgree-input').prop('checked'));
    this.validateInput(false);
  }

  // change event when auto apply is changed in cpp
  applyTypeChange(type: string) {
    this.applyType = type;
  }

  // page event captured of paginator to reset our binding aas it gets removed when data is refreshed on page change in grid
  pageEvent($event) {
    if ($event) {
      if ($event.previousPageIndex !== $event.pageIndex) {
        this.selectedProgram = undefined;
      }
    }
  }

  // Place the request
  placeRequest() {
    this.validateInput(true);
    let amount = 0;
    if (this.prePayContractType === 'CPP') {
      amount = this.cropProtectionPrePayAmount;
    } else {
      amount = this.prePayAmount;
    }

    if (amount.toString().indexOf('.') < 0 && amount.toString().length > 8) {
      amount = amount.toString().length === 9 ? (+amount / 10) : (amount.toString().length === 10 ? (+amount / 100) : +parseFloat((+amount / 1000).toString()).toFixed(2));
    }

    if (this.error === false) {
      const data = {
        AutoApply: this.selectedProgram.automaticManualPrepay,
        RequestType: 'A',
        AccountNumber: this.prePayRequestAccount,
        DateSigned: this.datePipe.transform(this.prePayDate, 'yyyy-MM-dd'),
        Description: this.selectedProgram.descriptionOfPrepay,
        Amount: amount,
        Supplier: this.selectedProgram.supplierName,
        ContractNumber: '',
        BusinessLine: '04',
        Company: this.headerCompany,
      };

      if (this.prePayContractType === 'CPP') {
        data.AutoApply = this.applyType;
        data.BusinessLine = '02';
      }
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.prePayService.addUpdateContractRequest(data).subscribe((result: any) => {
        if (result && result.status) {
          this.toastrService.success('Agreement Number #' + result.resultData[0].agreementNumberDistribution + ' created successfully.');
          this.prePayService.selectedAccount = this.prePayRequestAccount;
          this.loaderService.setLoaderStatus(false);
          this.router.navigate(['/prepay']);
        } else {
          // this.toastrService.error(result.message);
          this.toastrService.error('Your prepay request failed, please call WinField United customer service at 855-494-6343');
          this.loaderService.setLoaderStatus(false);
        }
      }, error => {
        this.toastrService.error('Your prepay request failed, please call WinField United customer service at 855-494-6343');
        this.loaderService.setLoaderStatus(false);
      }));
    }
  }

  validateInput(runValidation) {
    if (this.error || runValidation) {
      this.validateUserInput();
    }
  }

  // Validate the validations on form
  validateUserInput() {
    this.resetValidations();
    this.error = false;
    this.errorsList = [];

    if (this.prePayRequestAccount === undefined) {
      this.errorsList.push('Please select an Account');
      this.prepayContractValidation.Account = true;
    }
    if (this.selectedProgram === undefined) {
      this.errorsList.push('Please select a Prepay Program');
    }
    if (this.prePayContractType === undefined) {
      this.errorsList.push('Please select a Contract Type');
    }
    if ((this.prePayAmount === undefined || this.prePayAmount.toString() === '') && this.prePayContractType === 'SEED') {
      this.errorsList.push('Please provide prepay amount');
      this.prepayContractValidation.PrepayAmount = true;
    }
    if ((this.cropProtectionPrePayAmount === undefined || this.cropProtectionPrePayAmount.toString() === '') && this.prePayContractType === 'CPP') {
      this.errorsList.push('Please provide crop protection prepay amount');
      this.prepayContractValidation.CropProtectionPrePayAmount = true;
    }
    if (this.errorsList.length !== 0) {
      this.error = true;
    }
    this.termsConditionsClicked($('#cbIsAgree-input').prop('checked'));
  }

  // rest validations
  resetValidations() {
    this.prepayContractValidation.Account = false;
    this.prepayContractValidation.CropProtectionPrePayAmount = false;
    this.prepayContractValidation.PrepayAmount = false;
  }

  // Go back to Prepay landing page
  navigateToPrePay() {
    this.router.navigate(['/prepay']);
  }

  // Download terms and conditions file
  downloadFile() {
    this.loaderService.setLoaderStatus(true);
    let refrenceName = '';
    if (this.prePayContractType == 'SEED') {
      refrenceName = 'SEEDTERMSANDCONDITIONS';
    }
    else {
      refrenceName = 'CPPTERMSANDCONDITIONS';
    }
    this.subscription.push(this.prePayService.getTermsAndConditionByRefrenceName(refrenceName).subscribe((result: any) => {
      if (result) {
        if (result.fileData && result.objectName) {
          const extension = result.objectName.split('.').pop();
          const contentType = MasterConstants.CONTENT_TYPE_FOR_EXTENSIONS[extension.toLowerCase()];
          const a = document.createElement('a');
          a.href = 'data:' + contentType + ';base64,' + result.fileData;
          a.download = result.objectName;
          a.click();
          this.canEnableSubmit = false;
          this.isAgree = true;
          this.isTnSDownloaded = true;
          if (this.prePayContractType === 'SEED') {
            this.localStorageService.set(MasterConstants.SEED_TERMS_AND_CONDITION_DOWNLOADED, JSON.stringify(true));
          } else {
            this.localStorageService.set(MasterConstants.CPP_TERMS_AND_CONDITION_DOWNLOADED, JSON.stringify(true));
          }
          this.enableSubmit = false;
          this.loaderService.setLoaderStatus(false);
        }
        else {
          // this.toastrService.error(result.message);
          this.toastrService.error('No file available to download.');
          this.loaderService.setLoaderStatus(false);
        }
      } else {
        // this.toastrService.error(result.message);
        this.toastrService.error('No file available to download.');
        this.loaderService.setLoaderStatus(false);
      }
    }, error => {
      this.toastrService.error('Your prepay request failed, please call WinField United customer service at 855-494-6343');
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Terms and conditions checked event
  termsConditionsClicked(val) {
    this.termsSelected = val;
    if (this.canEnableSubmit === false && val && this.isTnSDownloaded && this.selectedProgram && this.error == false) {
      this.enableSubmit = true;
    }
    else {
      this.enableSubmit = false;
    }
  }

  // On page destroy
  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());

    this.prePayService.accountNo = undefined;
  }
}
